<template>
    <div id="paidCourseReceive">
        <div class="container">
            <div class="title">领取课程</div>
            <div class="form-item">
                <div class="label">手机号</div>
                <input v-model="tel" placeholder="请输入手机号" />
            </div>
            <div class="form-item">
                <div class="label">领取密码</div>
                <input v-model="passCheck" placeholder="请输入密码" />
            </div>
            <div v-if="accountSwitch" class="opts">
                <div @click="onSubmit" class="sub-btn">提交</div>
                <div @click="onLogout" class="logout-btn">切换账号</div>
            </div>
            <div v-else @click="onSubmit" class="sub-btn">提交</div>
        </div>
    </div>
</template>
<script>
import { urlQuery } from '@/utils/utils.js'
import { receiveCourse, bindTel } from '@/utils/api'
import { setUserInfo, getUserInfo, clearUserInfo } from '@/utils/login.js'

export default {
    name: 'paidCourseReceive',
    props: ['courseInfo', 'accountSwitch'],
    data() {
        return {
            tel: '',
            passCheck: '',
        }
    },
    methods: {
        onSubmit() {
            if (!new RegExp(/^1[0-9]{10}$/).test(this.tel)) {
                return this.$toast('手机号格式错误')
            }
            if (!this.passCheck) {
                return this.$toast('请输入密码')
            }
            this.$toast.loading({
                message: '加载中...',
                forbidClick: true,
            })
            const userInfo = getUserInfo()
            const options = urlQuery()
            const params = {
                packageNo: this.courseInfo.packageNo,
                userId: userInfo.id,
                passCheck: this.passCheck,
            }
            if (options && options.sn) {
                params.sourceFrom = options.sn
                params.sourceType = 2
            }
            receiveCourse(params).then(() => {
                this.$toast({ className: 'success-toast', message: '领取成功' })
                this.$emit('authSuccess', userInfo)
            })
            bindTel(this.tel).then(() => {
                userInfo.telNo = this.tel
                setUserInfo(userInfo)
            })
        },
        onLogout() {
            clearUserInfo()
            this.$toast({ message: '已退出登录', duration: 0 })
            setTimeout(() => {
                window.location.reload()
            }, 1000)
        }
    },
}
</script>
<style lang="scss">
#paidCourseReceive {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    .container {
        width: 320px;
        height: 220px;
        background: #fff;
        border-radius: 4px;
        box-sizing: border-box;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
    }
    .title {
        font-size: 16px;
        font-weight: 600;
    }
    .form-item {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .label {
        text-align: right;
        width: 64px;
        font-size: 14px;
        color: #666666;
    }
    input {
        height: 28px;
        width: 200px;
        border: 1px solid #aaa;
        border-radius: 4px;
        font-size: 14px;
        padding: 0 10px;
        box-sizing: border-box;
    }
    .sub-btn {
        width: 180px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #44cd94;
        color: #fff;
        border-radius: 4px;
        font-size: 14px;
        margin-top: 10px;
    }
    .opts {
        margin-top: 10px;
        width: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        .sub-btn {
            margin-top: 0;
            width: 160px;
            margin-right: 24px;
        }
        .logout-btn {
            cursor: pointer;
            position: absolute;
            top: 50%;
            font-size: 14px;
            transform: translateY(-50%);
            right: 0;
            color: #5b5a5a;
            text-decoration: underline;
        }
    }
}
</style>
